import React from "react";
import styled from "styled-components";
import PeriodicTable from "./components/PeriodicTable.js";
import Search from "./components/Search";
import { PeriodicTableProvider } from "./components/PeriodicTableContext";
import ProductGrid from "./components/ProductGrid";

const SearchApp = styled.div`
  padding: 0 8px;
	max-width: 1140px;
`;

function App() {
  return (
    <SearchApp className="search-app">
      <PeriodicTableProvider>
        <Search />
        <PeriodicTable />
        <ProductGrid />
      </PeriodicTableProvider>
    </SearchApp>
  );
}

export default App;
